import { UnitSystem } from 'MeasurementsCalculations';

export enum SymbolUnitSystem {
  m,
  e,
  u,
  j,
  NotDefined,
  Metric,
  European,
  Us,
  Japanese,
}

export function GetSymbolUnitSystem(s: string): UnitSystem {
  switch (s.toLowerCase()) {
    case 'm':
      return UnitSystem.Metric;
    case 'e':
      return UnitSystem.European;
    case 'u':
      return UnitSystem.Us;
    case 'j':
      return UnitSystem.Japanese;
    case 'notdefined':
      return UnitSystem.NotDefined;
    case 'metric':
      return UnitSystem.Metric;
    case 'european':
      return UnitSystem.European;
    case 'us':
      return UnitSystem.Us;
    case 'japanese':
      return UnitSystem.Japanese;
    default:
      return UnitSystem.Metric;
  }
}
